<template>
  <div>
    <load v-if="loading" :mode="mode" />
    <div v-else id="boxPrint" class="row">
      <div class="col-md-12">
        <print-content>
          <table class="table table-bordered bg-white table-sm">
            <tbody>
              <tr>
                <td colspan="2" class="text-center">
                  <h1 class="h3 mb-3 text-gray-800">
                    {{ $t(titulo || "Detalhes do Acolhimento") }}
                  </h1>
                </td>
              </tr>
              <tr>
                <td>
                  ID:<b>{{ item.id }}</b> Protocolo:<b>{{ item.protocolo }}</b>
                </td>
                <td>
                  Criado:<b>{{ item.cadastrado }}</b>
                </td>
              </tr>
              <tr>
                <td>
                  Técnico Responsável:<b v-if="item.responsavel">{{
                    item.responsavel.name
                  }}</b>
                </td>
                <td>
                  Atualizado:<b>{{ item.atualizado }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Unidade:<b v-if="item.unidade">{{ item.unidade.nome }}</b>
                </td>
              </tr>
              <tr>
                <td class="text-center" colspan="2">
                  <h5 class="font-weight-bold text-center">
                    Identificação do adolescente
                  </h5>
                </td>
              </tr>
              <tr>
                <td>
                  Nome:
                  <b v-if="item.usuario_nome">{{ item.usuario_nome }} </b>
                </td>
                <td>
                  Idade:
                  <b v-if="item.usuario_idade"
                    >{{ item.usuario_idade }} Anos
                  </b>
                </td>
              </tr>
              <tr>
                <td>
                  Data de Nascimento:
                  <strong v-if="item.adolescente.data_nascimento">{{
                    item.adolescente.data_nascimento | formatDate
                  }}</strong>
                </td>
                <td>
                  Naturalidade:
                  <strong v-if="item.adolescente.municipio_nascimento">
                    {{ item.adolescente.municipio_nascimento }}-{{
                      getValue(
                        item.adolescente.uf_nascimento,
                        $root.arrays.estados
                      )
                    }}</strong
                  >
                </td>
              </tr>
              <tr>
                <td>
                  Situação Conjugal:
                  <strong v-if="item.adolescente.estado_civil">
                    {{
                      getValue(
                        item.adolescente.estado_civil,
                        $root.arrays.estado_civil
                      )
                    }}</strong
                  >
                </td>
                <td>
                  Telefone:
                  <strong v-if="item.familia.contato">
                    {{ item.familia.contato.telefone_um }} /
                    {{ item.familia.contato.telefone_dois }}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Endereço:
                  <strong v-if="item.endereco"
                    >{{ item.endereco.logradouro.tipo }}
                    {{ item.endereco.logradouro.nome_logradouro }},
                    {{ item.endereco.numero }}</strong
                  >
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Responsável:
                  <strong v-if="item.familia.responsavel_familiar">{{
                    item.familia.responsavel_familiar.nome_completo
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.adolescente.documento">
                <td>
                  RG:
                  <strong>{{ item.adolescente.documento.rg }}</strong>
                </td>
                <td></td>
              </tr>
              <tr v-if="item.adolescente.documento">
                <td colspan="2">
                  Certidão de Nascimento:
                  <strong>{{
                    item.adolescente.documento.termo_certidao
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.adolescente.documento">
                <td>
                  Titulo de Eleitor:
                  <strong>{{
                    item.adolescente.documento.titulo_eleitor
                  }}</strong>
                </td>
                <td>
                  Alistamento Militar:
                  <strong>{{
                    item.adolescente.documento.alistamento_militar
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.adolescente.documento">
                <td>
                  PIS/PASEP:
                  <strong>{{ item.adolescente.documento.pis_pasep }}</strong>
                </td>
                <td>
                  Carteira do SUS:
                  <strong>{{ item.adolescente.documento.cartao_sus }}</strong>
                </td>
              </tr>
              <tr>
                <td class="text-center" colspan="2">
                  <h5 class="font-weight-bold text-center">Dados</h5>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Solicitação de vaga:
                  <strong>{{ item.unidade.nome }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Termo de Acolhimento:
                  <strong>{{ item.termo_colhimento }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  Data do Acolhimento:
                  <strong>{{ item.data_acolhimento_pia }}</strong>
                </td>
                <td>
                  Horário:
                  <strong>{{ item.hora_acolhimento_pia }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  Possui irmão na unidade de acolhimento:
                  <strong>
                    {{
                      getValue(item.possui_irmao_unidade, $root.arrays.pergunta)
                    }}
                  </strong>
                </td>
                <td>
                  Quantos:
                  <strong>{{ item.quant_irmao_unidade }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Motivo(s) do acolhimento:
                  <strong
                    class="badge bg-light border text-dark"
                    v-for="(m, i) in item.motivo"
                    :key="i"
                    >{{ getValue(m, $root.arrays.acolhimento_motivo) }}</strong
                  >
                </td>
              </tr>

              <tr>
                <td class="text-center" colspan="2">
                  <h5 class="font-weight-bold text-center">Detalhes</h5>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Criança/Adolescente incluído no Cadastro Nacional da Criança
                  ou Adolescente Desaparecido?
                  <strong>{{
                    getValue(
                      item.crianca_cadastro_desaparecida,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Criança/adolescente está incluído no Cadastro Nacional de
                  Adoção?
                  <strong>{{
                    getValue(
                      item.crianca_cadastro_adocao,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  Adolescente cumprindo Medida Socioeducativa?
                  <strong>{{
                    getValue(item.cumprimento_medidas, $root.arrays.pergunta)
                  }}</strong>
                </td>
                <td>
                  Qual:
                  <strong>{{ item.tipo_medida_nome }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Criança/Adolescente foi acolhida anteriormente?
                  <strong>
                    {{
                      getValue(
                        item.acolhido_anteriomente,
                        $root.arrays.pergunta
                      )
                    }}
                  </strong>
                </td>
              </tr>
              <tr>
                <td>
                  Unidade Acolhedora:
                  <strong>{{ item.medida_nome_unidade }}</strong>
                </td>
                <td>
                  Data inicio:
                  <strong>{{ item.medida_data_entrada_pia }}</strong>
                  Data Final:
                  <strong>{{ item.medida_data_saida_pia }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Medida protetiva de acolhimento institucional aplicada:
                  <strong>
                    {{
                      getValue(
                        item.medida_protetiva_aplicada,
                        $root.arrays.medida_protetiva_aplicada
                      )
                    }}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Considerando os motivos do acolhimento, informe quem é / ou
                  são o(s) suposto(s) autor(es) da violência/violação de
                  direitos ou responsável(is) que está(ão) impossibilitado(s) de
                  prestar os cuidados e proteção necessários à
                  criança/adolescente?
                  <strong>
                    {{
                      getValue(
                        item.autores_violencia_violacao,
                        $root.arrays.autores_violencia_violacao
                      )
                    }}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Foram aplicadas outras medidas de proteção antes do
                  acolhimento?
                  <strong>
                    {{
                      getValue(
                        item.medidas_antes_acolhimento,
                        $root.arrays.pergunta
                      )
                    }}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Qual?
                  <strong
                    class="badge bg-light border text-dark"
                    v-for="(m, i) in item.autores_violencia_violacao_outro"
                    :key="i"
                    >{{
                      getValue(m, $root.arrays.medidas_antes_aplicadas)
                    }}</strong
                  >
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Há impedimento judicial que impeça o contato dos
                  pais/responsáveis com a criança/adolescente?
                  <strong>{{
                    getValue(item.impedimento_judicial, $root.arrays.pergunta)
                  }}</strong>
                </td>
              </tr>

              <tr>
                <td class="text-center" colspan="2">
                  <h5 class="font-weight-bold text-center">
                    Documentação/Identificação Processual
                  </h5>
                </td>
              </tr>
              <tr>
                <td class="bg-light text-center" colspan="2">
                  <strong>Listagem de documentos</strong>
                </td>
              </tr>
              <tr v-for="documento in item.documentacao" :key="documento.id">
                <td>
                  <strong>{{
                    getValue(
                      documento.documento,
                      $root.arrays.acolhimento_documentacao
                    )
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    getValue(
                      documento.acao,
                      $root.arrays.acolhimento_documentacao_acao
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td class="bg-light text-center" colspan="2">
                  <strong>Dados Jurídicos</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Número do Processo:
                  <strong v-if="item.dadosJuridicos">{{
                    item.dadosJuridicos.numero_processo
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Número da Guia de Acolhimento:
                  <strong v-if="item.dadosJuridicos">{{
                    item.dadosJuridicos.numero_guia_acolhimento
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Número da Guia de Desligamento:
                  <strong v-if="item.dadosJuridicos">{{
                    item.dadosJuridicos.numero_guia_desligamento
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Nome do Tribunal:
                  <strong v-if="item.dadosJuridicos">{{
                    item.dadosJuridicos.nome_tribunal
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Nome da Comarca:
                  <strong v-if="item.dadosJuridicos">{{
                    item.dadosJuridicos.nome_comarca
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Nome da Vara Especializada responsável pelo caso:
                  <strong v-if="item.dadosJuridicos">{{
                    item.dadosJuridicos.nome_responsavel_caso
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Endereço da Vara Especializada:
                  <strong v-if="item.dadosJuridicos">{{
                    item.dadosJuridicos.endereco_vara
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Pessoa de referência na Vara Especializada:
                  <strong v-if="item.dadosJuridicos">{{
                    item.dadosJuridicos.pessoa_referencia_vara
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Telefones da pessoa de referência na Vara Especializada:
                  <strong v-if="item.dadosJuridicos">{{
                    item.dadosJuridicos.telefone_pessoa_referencia
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td class="text-center" colspan="2">
                  <h5 class="font-weight-bold text-center">
                    Composição Familiar
                  </h5>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Constituição Familiar Atual:
                  <strong>{{
                    getValue(
                      item.familia.constituicao,
                      $root.arrays.constituicao
                    )
                  }}</strong>
                </td>
              </tr>

              <tr v-for="(familiar, index) in item.familiares" :key="index">
                <td colspan="2">
                  <div class="d-flex d-block justify-content-between">
                    <div
                      class="p-2 border border-dark border-1 flex-fill border-right-0"
                    >
                      Nome:
                      <strong>{{ familiar.nome_completo }}</strong>
                    </div>
                    <div class="p-2 border border-dark border-1 flex-fill">
                      Data Nascimento:
                      <strong>{{
                        familiar.data_nascimento | formatDate
                      }}</strong>
                    </div>
                  </div>

                  <div
                    class="d-block p-2 border border-dark border-1 border-bottom-0 border-top-0"
                  >
                    Posição Familiar:
                    <strong>{{
                      getValue(
                        parseInt(familiar.posicao_familiar),
                        $root.arrays.posicao_familiar
                      )
                    }}</strong>
                  </div>

                  <div class="d-flex d-block justify-content-between">
                    <div
                      class="p-2 border border-dark border-1 flex-fill border-right-0"
                    >
                      Profissão:
                      <strong>{{ familiar.remuneracao.profissao_nome }}</strong>
                    </div>
                    <div class="p-2 border border-dark border-1 flex-fill">
                      Renda:
                      <strong
                        >R$ {{ familiar.remuneracao.total_rendas }}</strong
                      >
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="text-center" colspan="2">
                  <h5 class="font-weight-bold text-center">
                    Dinâmica Familiar
                  </h5>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  Em estudo e acompanhamento da situação familiar:
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.estudo_acompanhamento,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Criança/adolescente órfão:
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.crianca_orfao,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Preparação para reintegração familiar (família natural):
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.preparacao_reintegracao_natural,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Preparação para reintegração familiar (família extensa):
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.preparacao_reintegracao_extensa,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Poder familiar destituído:
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.poder_fam_destituido,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Em processo de guarda/tutela/adoção:
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.processo_guarda,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Sem informação da família:
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.sem_informacao,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Informações adicionais sobre a família:
                  <strong
                    v-if="item.dinamicaFamiliar"
                    v-html="item.dinamicaFamiliar.informacoes_adicionais"
                  ></strong>
                </td>
              </tr>
              <tr>
                <td>
                  Interagem entre si?
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.familia_interagem,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
                <td>
                  Se afirmativo, de que forma?
                  <strong v-if="item.dinamicaFamiliar">{{
                    item.dinamicaFamiliar.forma_interacao
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Demonstram alguma preferência?
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.demontra_preferencia,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Há exclusão, não aceitação de algum membro?
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.exclusao_aceitacao_membro,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Isolamento de um dos membros?
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.isolamento_membro,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Tomada de atitude em relação ao filho:
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.tomada_atitude,
                      $root.arrays.acolhimento_tomada_atitude
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="bg-light">
                  Relação dos pais ou responsáveis com o profissional
                  responsável pela visita: (na frente de cada item colocar a
                  qual responsável se refere. Ex. pai, mãe, avó, avô.
                </td>
              </tr>
              <tr v-for="(r, i) in item.dinamicaFamiliarRelacao" :key="i">
                <td>
                  <strong>{{ r.responsavel }}</strong>
                </td>
                <td>
                  <strong>{{
                    getValue(
                      r.tipo_relacao,
                      $root.arrays.acolhimento_tipo_relacao
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Dificuldade em estabelecer a relação interpessoal?
                  <strong v-if="item.dinamicaFamiliar">{{
                    getValue(
                      item.dinamicaFamiliar.dificuldade_relacao,
                      $root.arrays.acolhimento_tomada_atitude
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Por quê?
                  <strong v-if="item.dinamicaFamiliar">
                    {{ item.dinamicaFamiliar.dificuldade_por_que }}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Intervenções e percepções do profissional durante o
                  acompanhamento
                  <strong
                    v-if="item.dinamicaFamiliar"
                    v-html="item.dinamicaFamiliar.intervencao_percepcao"
                  >
                  </strong>
                </td>
              </tr>

              <tr>
                <td class="text-center" colspan="2">
                  <h5 class="font-weight-bold text-center">
                    Primeira Observação
                  </h5>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  A criança/adolescente encontrava-se em boas condições de
                  higiene?
                  <strong v-if="item.primeiraObservacao">{{
                    getValue(
                      item.primeiraObservacao.condicao_higiene,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  A criança/adolescente estava agitada ao chegar na
                  unidade?<strong v-if="item.primeiraObservacao">{{
                    getValue(
                      item.primeiraObservacao.chegou_agitada,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  A criança/adolescente estava chorando ao chegar na unidade?
                  <strong v-if="item.primeiraObservacao">{{
                    getValue(
                      item.primeiraObservacao.chegou_chorando,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  A criança/adolescente apresentou dificuldade para dormir?
                  <strong v-if="item.primeiraObservacao">{{
                    getValue(
                      item.primeiraObservacao.dificuldade_dormir,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  A criança/adolescente apresentou enurese noturna?
                  <strong v-if="item.primeiraObservacao">{{
                    getValue(
                      item.primeiraObservacao.enurese_noturna,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  A criança adolescente apresentava vestígios do uso de alguma
                  substância psicoativa?
                  <strong v-if="item.primeiraObservacao">{{
                    getValue(
                      item.primeiraObservacao.vestigio_psicoativo,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  A criança adolescente apresentava algum sinal de violência
                  física?
                  <strong v-if="item.primeiraObservacao">{{
                    getValue(
                      item.primeiraObservacao.violencia_fisica,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  A criança adolescente apresentava algum sinal de violência
                  sexual?
                  <strong v-if="item.primeiraObservacao">{{
                    getValue(
                      item.primeiraObservacao.violacia_sexual,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  A criança adolescente apresentava aspectos que indicam a
                  vivência de negligência?
                  <strong v-if="item.primeiraObservacao">{{
                    getValue(
                      item.primeiraObservacao.vivencia_negligencia,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2" v-if="item.primeiraObservacao">
                  Aspectos pessoais observados:
                  <strong
                    class="badge bg-light border text-dark"
                    v-for="(a, i) in item.primeiraObservacao.aspectos_pessoais"
                    :key="i"
                    >{{
                      getValue(a, $root.arrays.acolhimento_aspectos_pessoais)
                    }}</strong
                  >
                </td>
              </tr>
              <tr>
                <td class="text-center" colspan="2">
                  <h5 class="font-weight-bold text-center">
                    Saúde e Desenvolvimento
                  </h5>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="bg-light text-center">
                  <strong>Linguagem</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Pronuncia corretamente as palavras?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.pronuncia_correta,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Troca letras?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.troca_letra,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Omite letras?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.omite_letras,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Apresenta gagueiras?
                  <strong v-if="item.caractSaude">{{
                    getValue(item.caractSaude.gagueira, $root.arrays.pergunta)
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Compreende perguntas que lhe são feitas?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.compreende_perguntas,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="bg-light text-center">
                  <strong>Alimentação</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Tem bom apetite?
                  <strong v-if="item.caractSaude">{{
                    getValue(item.caractSaude.apetite, $root.arrays.pergunta)
                  }}</strong>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  Tem alergia a algum alimento?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.alergia_alimento,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  Recusa alimentação?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.recusa_alimentar,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  Necessita de ajuda para se alimentar?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.ajuda_alimentar,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="bg-light text-center">
                  <strong>Saúde</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Possui cartão de vacina?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.cartao_vacina,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  O cartão está atualizado?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.cartao_atualizado,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  É estabanada (esbarra nos móveis, derruba água ou comida na
                  mesa)?
                  <strong v-if="item.caractSaude">{{
                    getValue(item.caractSaude.estabanada, $root.arrays.pergunta)
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Apresenta algum problema ortopédico (pé chato, torto etc.)?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.problema_ortopedico,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Aproxima muito os objetos para vê-los?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.aproxima_objetos,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Aperta os olhos para olhar à distância?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.aperta_olhos,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Costuma ter inflamações nos ouvidos?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.inflamacao_ouvidos,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Apresenta reações diferentes a ruídos diferentes?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.reacao_ruidos,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Apresenta alguma reação especial a diferentes tipos de cheiro
                  e gosto?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.reacao_cheiros,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Tomou as vacinas necessárias conforme a idade?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.tomou_vacinas,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Que doenças infantis já teve?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.doencas_infantis,
                      $root.arrays.acolhimento_doencas_infantis
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Quais outras doenças?
                  <strong v-if="item.caractSaude">{{
                    item.caractSaude.doencas_outras
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Faz uso constante ou prolongado de medicamentos?
                  <strong v-if="item.caractSaude">{{
                    getValue(
                      item.caractSaude.uso_prolongado_medicamento,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr
                v-if="
                  item.caractSaude &&
                  item.caractSaude.uso_prolongado_medicamento == 1
                "
              >
                <td>
                  Quais?
                  <strong>{{ item.caractSaude.uso_medicamento_quais }}</strong>
                </td>
                <td>
                  Qual periodo?
                  <strong>{{
                    item.caractSaude.uso_medicamento_periodo
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td>
                  Tem alergias?
                  <strong>{{
                    getValue(item.caractSaude.alergia, $root.arrays.pergunta)
                  }}</strong>
                </td>
                <td>
                  A que?<strong>{{ item.caractSaude.alergia_a_que }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td>
                  Já sofreu algum acidente ou queda?
                  <strong>{{
                    getValue(
                      item.caractSaude.sofreu_acidente,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
                <td>
                  Como reagiu?<strong>{{
                    item.caractSaude.como_reagiu_acidente
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Precisa de algum cuidado especial por motivo de saúde?
                  <strong>{{
                    getValue(
                      item.caractSaude.cuidado_especial,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Há indicação para acompanhamento psicológico?
                  <strong>{{
                    getValue(
                      item.caractSaude.ind_acompanhamento_psicologico,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Já passou por acompanhamento psicológico?
                  <strong>{{
                    getValue(
                      item.caractSaude.ja_acompanhamento_psicologico,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  É necessário encaminhamento para Atendimento médico
                  especializado?
                  <strong>{{
                    getValue(
                      item.caractSaude.encaminhar_atendimento_medico,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr
                v-if="
                  item.caractSaude &&
                  item.caractSaude.encaminhar_atendimento_medico == 1
                "
              >
                <td colspan="2">
                  Quais?
                  <strong>{{
                    item.caractSaude.atendimento_medico_quais
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="bg-light text-center">
                  <strong>Sexualidade</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Sua sexualidade é compatível com a idade?
                  <strong>{{
                    getValue(
                      item.caractSaude.sexualidade_compativel_idade,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr
                v-if="
                  item.caractSaude &&
                  item.caractSaude.sexualidade_compativel_idade == 1
                "
              >
                <td colspan="2">
                  Por que?
                  <strong>{{
                    item.caractSaude.sexualidade_compativel_porque
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="bg-light text-center">
                  <strong>
                    Tiques (atos involuntários) e Manipulações (atos
                    voluntários)</strong
                  >
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td>
                  Usa chupeta?
                  <strong>{{
                    getValue(item.caractSaude.chupeta, $root.arrays.pergunta)
                  }}</strong>
                </td>
                <td>
                  Rói unhas?
                  <strong>{{
                    getValue(item.caractSaude.roi_unha, $root.arrays.pergunta)
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td>
                  Chupa dedo?
                  <strong>{{
                    getValue(item.caractSaude.chupa_dedo, $root.arrays.pergunta)
                  }}</strong>
                </td>
                <td>
                  Apresenta algum tique?
                  <strong>{{
                    getValue(
                      item.caractSaude.apresenta_tique,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Descrição Tique
                  <strong v-html="item.caractSaude.tique_descricao"></strong>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="bg-light text-center">
                  <strong>Emoções/Comportamentos</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td>
                  Demonstrou medo?
                  <strong>{{
                    getValue(item.caractSaude.medo, $root.arrays.pergunta)
                  }}</strong>
                </td>
                <td>
                  De que?
                  <strong>{{ item.caractSaude.medo_de_que }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td>
                  Irrita- se facilmente?
                  <strong>{{
                    getValue(
                      item.caractSaude.irrita_facil,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
                <td>
                  Como reage quando frustrado?
                  <strong>{{ item.caractSaude.reage_frustacao }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Como expressa suas emoções? (é espontâneo nos afetos, tolhido,
                  foge dos contatos):
                  <strong>{{ item.caractSaude.expressa_emocoes }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Como reage quando tem raiva? (isola - se, torna-se agressivo):
                  <strong>{{ item.caractSaude.reage_raiva }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Chora frequentemente?
                  <strong>{{
                    getValue(
                      item.caractSaude.chora_frequente,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="bg-light text-center">
                  <strong>Disciplina</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Necessita de ser disciplinado?
                  <strong>{{
                    getValue(
                      item.caractSaude.necessita_disciplina,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Aceita ser disciplinado?
                  <strong>{{
                    getValue(
                      item.caractSaude.aceita_disciplina,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Respeita a figura da autoridade?
                  <strong>{{
                    getValue(
                      item.caractSaude.respeita_autoridade,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>

              <tr>
                <td colspan="2" class="bg-light text-center">
                  <strong>Relacionamento com pais/amigos/em sociedade</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Tem boa aproximação com o pai?
                  <strong>{{
                    getValue(
                      item.caractSaude.aproximacao_pai,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Tem boa aproximação com a mãe?
                  <strong>{{
                    getValue(
                      item.caractSaude.aproximacao_mae,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Mostra preferência por um dos dos genitores?
                  <strong>{{
                    getValue(
                      item.caractSaude.preferencia_genitores,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Por qual motivo?
                  <strong>{{
                    getValue(
                      item.caractSaude.preferencia_genitores_motivo,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Relaciona-se bem com os outros acolhidos?
                  <strong>{{
                    getValue(
                      item.caractSaude.bem_entre_irmaos,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Relaciona-se bem com os funcionários?
                  <strong>{{
                    getValue(
                      item.caractSaude.relacao_boa_funcionarios,
                      $root.arrays.pergunta
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Com quem brinca?
                  <strong>{{
                    getValue(item.caractSaude.brinca, $root.arrays.pergunta)
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Brinca com pessoas?
                  <strong>{{
                    getValue(
                      item.caractSaude.brinca_com_pessoas,
                      $root.arrays.acolhimento_brinca_com_pessoas
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.caractSaude">
                <td colspan="2">
                  Não brinca, só observa?
                  <strong>{{
                    getValue(item.caractSaude.nao_brinca, $root.arrays.pergunta)
                  }}</strong>
                </td>
              </tr>
              <template v-if="item.educacao">
                <tr>
                  <td class="text-center" colspan="2">
                    <h5 class="font-weight-bold text-center">Educação</h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    Houve interrupção nos estudos?
                    <strong>{{
                      getValue(
                        item.educacao.interrupcao_estudos,
                        $root.arrays.pergunta
                      )
                    }}</strong>
                  </td>
                  <td>
                    Apresenta dificuldade de aprendizagem
                    <strong>{{
                      getValue(
                        item.educacao.dificuldade_aprendizagem,
                        $root.arrays.pergunta
                      )
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Frequenta Programas Sociais – contra turno escolar?
                    <strong>{{
                      getValue(
                        item.educacao.frequenta_programa_social,
                        $root.arrays.pergunta
                      )
                    }}</strong>
                  </td>
                </tr>
                <tr v-if="item.educacao.frequenta_programa_social == 1">
                  <td colspan="2">
                    Qual a unidade?
                    <strong>{{ item.educacao.unidade_programa_social }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Qual método de ensino teria maior facilidade de aprendizagem
                    em razão do seu perfil comportamental:
                    <strong v-html="item.educacao.metodo_aprendizagem"></strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Considerações sobre a vida escolar
                    (frequência,comportamento, aprendizagem):
                    <strong
                      v-html="item.educacao.consideracao_escolar"
                    ></strong>
                  </td>
                </tr>
              </template>
              <template v-if="item.profissionalizacao">
                <tr>
                  <td colspan="2" class="text-center">
                    <h5
                      v-if="item.profissionalizacao"
                      class="font-weight-bold text-center"
                    >
                      Profissionalização
                    </h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    Está Trabalhando?
                    <strong>{{
                      getValue(
                        item.profissionalizacao.trabalhando,
                        $root.arrays.pergunta
                      )
                    }}</strong>
                  </td>
                  <td>
                    Qual o local do Trabalho?
                    <strong>{{ item.profissionalizacao.local }}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Horário
                    <strong>{{ item.profissionalizacao.horario }}</strong>
                  </td>
                  <td>
                    Salário
                    <strong>{{ item.profissionalizacao.salario }}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Registro em Carteira?
                    <strong>{{
                      getValue(
                        item.profissionalizacao.registro_carteira,
                        $root.arrays.pergunta
                      )
                    }}</strong>
                  </td>
                  <td>
                    Experiências anteriores?
                    <strong>{{
                      getValue(
                        item.profissionalizacao.experiencia_anterior,
                        $root.arrays.pergunta
                      )
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Já participou de cursos profissionalizantes?
                    <strong>{{
                      getValue(
                        item.profissionalizacao.participou_cursos,
                        $root.arrays.pergunta
                      )
                    }}</strong>
                  </td>
                  <td>
                    Quais cursos profissionalizantes?
                    <strong>{{ item.profissionalizacao.qual_curso }}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Gostaria de participar de cursos profissionalizantes?
                    <strong>{{
                      getValue(
                        item.profissionalizacao.gostaria_participar,
                        $root.arrays.pergunta
                      )
                    }}</strong>
                  </td>
                  <td>
                    Quais cursos gostaria de participar?
                    <strong>{{
                      item.profissionalizacao.quais_cursos_gostaria_participar
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Deseja seguir alguma profissão?
                    <strong>{{
                      getValue(
                        item.profissionalizacao.deseja_alguma_profissao,
                        $root.arrays.pergunta
                      )
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Qual das profissã de acordo com a CLASSIFICAÇÃO BRASILEIRA
                    DE OCUPAÇÕES tem interesse de seguir?
                    <strong>{{
                      getValue(
                        item.profissionalizacao.qual_profissao_interesse,
                        $root.ocupacoes
                      )
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Observação sobre as competências profissionais
                    identificadas/aptidões
                    <strong
                      v-html="item.profissionalizacao.observacoes"
                    ></strong>
                  </td>
                </tr>
              </template>
              <template v-if="item.obsVisitaResponsavel">
                <tr>
                  <td colspan="2" class="text-center">
                    <h5
                      v-if="item.obsVisitaResponsavel"
                      class="font-weight-bold text-center"
                    >
                      Observação na Visita Familiar
                    </h5>
                  </td>
                </tr>
                <tr
                  v-for="obsResp in item.obsVisitaResponsavel"
                  :key="obsResp.id"
                >
                  <td colspan="2">
                    Na visita a criança/adolescente demonstra(m)
                    <strong>{{
                      getValue(
                        obsResp.sentimento,
                        $root.arrays.acolhimento_observacao_visita
                      )
                    }}</strong>
                    com o(a)
                    <strong>{{ obsResp.responsavel }}</strong>
                  </td>
                </tr>
                <tr v-for="obAsp in item.obsVisitaAspecto" :key="obAsp.id">
                  <td colspan="2">
                    Aspectos emocionais na relação com a criança/adolescente:
                    <strong>{{ obAsp.responsavel }}</strong>
                    Ação:
                    <strong>{{
                      getValue(
                        obAsp.acao,
                        $root.arrays.acolhimento_observacao_visita_aspectos
                      )
                    }}</strong>
                  </td>
                </tr>
              </template>
              <template v-if="item.metaCrianca">
                <tr>
                  <td colspan="2" class="text-center">
                    <h5
                      v-if="item.metaCrianca"
                      class="font-weight-bold text-center"
                    >
                      Objetivos e Metas - Criança e Adolescente
                    </h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>Situação Documental</h5>
                  </td>

                  <td>
                    Prazo:
                    <strong>{{
                      item.metaCrianca.documental_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaCrianca.documental_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaCrianca.documental_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td><h5>Situação Processual</h5></td>
                  <td>
                    Prazo:
                    <strong>{{
                      item.metaCrianca.processual_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaCrianca.processual_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaCrianca.processual_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1"><h5>Saúde</h5></td>
                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaCrianca.saude_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaCrianca.saude_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaCrianca.saude_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1"><h5>Educação</h5></td>
                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaCrianca.educacao_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaCrianca.educacao_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Metal:
                    <p v-html="item.metaCrianca.educacao_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Profissionalização</h5>
                  </td>
                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaCrianca.profissionalizacao_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p
                      v-html="
                        item.metaCrianca.profissionalizacao_situacao_atual
                      "
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaCrianca.profissionalizacao_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Arte, Cultura, Esporte E Lazer</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaCrianca.arte_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaCrianca.arte_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaCrianca.arte_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Aspectos Sociofamiliares</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaCrianca.aspecto_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaCrianca.aspecto_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaCrianca.aspecto_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Condições Socioeconômicas</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaCrianca.condicao_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaCrianca.condicao_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaCrianca.condicao_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Vulnerabilidade sociofamiliares</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaCrianca.vulnerabildiade_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual :
                    <p
                      v-html="item.metaCrianca.vulnerabildiade_situacao_atual"
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaCrianca.vulnerabildiade_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Autonomia / autoestima / identidade</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaCrianca.autonomia_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaCrianca.autonomia_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaCrianca.autonomia_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Preparação para desligamento</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaCrianca.desligamento_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p
                      v-html="item.metaCrianca.desligamento_situacao_atual"
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaCrianca.desligamento_meta"></p>
                  </td>
                </tr>
              </template>
              <template v-if="item.metaResponsavel">
                <tr>
                  <td colspan="2">
                    <h5
                      v-if="item.metaResponsavel"
                      class="font-weight-bold text-center"
                    >
                      Objetivos e Metas - Pais e Responsáveis
                    </h5>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Situação Documental</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.documental_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p
                      v-html="item.metaResponsavel.documental_situacao_atual"
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaResponsavel.documental_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Situação Processual</h5>
                  </td>
                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.processual_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p
                      v-html="item.metaResponsavel.processual_situacao_atual"
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaResponsavel.processual_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1"><h5>Saúde</h5></td>
                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.saude_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaResponsavel.saude_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaResponsavel.saude_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1"><h5>Educação</h5></td>
                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.educacao_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p
                      v-html="item.metaResponsavel.educacao_situacao_atual"
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Metal:
                    <p v-html="item.metaResponsavel.educacao_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Profissionalização</h5>
                  </td>
                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.profissionalizacao_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p
                      v-html="
                        item.metaResponsavel.profissionalizacao_situacao_atual
                      "
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p
                      v-html="item.metaResponsavel.profissionalizacao_meta"
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Arte, Cultura, Esporte E Lazer</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.arte_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaResponsavel.arte_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaResponsavel.arte_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Aspectos Sociofamiliares</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.aspecto_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaResponsavel.aspecto_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaResponsavel.aspecto_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Condições Socioeconômicas</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.condicao_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p
                      v-html="item.metaResponsavel.condicao_situacao_atual"
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaResponsavel.condicao_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Vulnerabilidade sociofamiliares</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.vulnerabildiade_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual :
                    <p
                      v-html="
                        item.metaResponsavel.vulnerabildiade_situacao_atual
                      "
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaResponsavel.vulnerabildiade_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Relação com a unidade de acolhimento</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.relacao_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p v-html="item.metaResponsavel.relacao_situacao_atual"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaResponsavel.relacao_meta"></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <h5>Preparação para desligamento</h5>
                  </td>

                  <td colspan="1">
                    Prazo:
                    <strong>{{
                      item.metaResponsavel.desligamento_prazo | formatDate
                    }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Situação Atual:
                    <p
                      v-html="item.metaResponsavel.desligamento_situacao_atual"
                    ></p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Objetivo/Meta:
                    <p v-html="item.metaResponsavel.desligamento_meta"></p>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <p v-if="mode != 'table'" class="text-muted">
            {{ app_cidade }}, {{ app_data_atual }}
          </p>
          <print-footer
            v-if="item.responsavel.tecnico.assinatura_digital"
            :tecnico="item.responsavel.tecnico"
            class="mt-0"
            :assinatura="item.responsavel.tecnico.assinatura_digital"
            :wpp="wpp"
            :email="email"
          />

          <form-toggle
            grid="12"
            mt="0"
            v-model="email"
            label="Email"
          />
          <form-toggle
            grid="12"
            mt="0"
            v-model="wpp"
            label="Telefone/WhatsApp"
          />
          
          <div class="box-btn-print no-print">
            <router-link
              v-if="mode != 'table'"
              :to="`/dashboard/acolhimentos/${item.unidade_id}`"
              class="btn btn-default btn-sm d-block py-2"
            >
              <i class="mdi mdi-arrow-left" />
            </router-link>

            <b-button
              :title="$t('Imprimir')"
              class="py-2"
              size="sm"
              type="button"
              v-b-tooltip.hover
              variant="primary"
              @click="print()"
            >
              <i class="fas fa-print"></i>
            </b-button>
          </div>
        </print-content>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["titulo", "mode"],
  name: "Show",
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      tipos: [],
      tecnicos: [],
      unidades: [],
    };
  },
  mounted() {
    this.getItem();
  },
  methods: {
    getPrazo(data) {
      if (data) {
        var data_final = moment(data);
        var data_atual = moment();
        var prazo = data_final.diff(data_atual, "months");
        return prazo + " mes(es)";
      }
    },
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/acolhimento/get/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push(`/dashboard/acolhimento/unidades`);
        });
    },
    getValue(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
  },
};
</script>

<style></style>
